import {MrAccount, MrLife, MrLifeBenefit, MrSubscription, MrSubscriptionQuoteRequest,} from '@peachy/core-domain-pure'

import {Draft, KeyMapped, mapBy, mapById, newUUID, omit, pick, values} from '@peachy/utility-kit-pure'


import {
    QuoteBenefit,
    QuoteLife,
    QuoteLifeRequest,
    QuoteParameterSet,
    quoteRegionMap,
    toQuoteBenefitType
} from '@peachy/quote-pure'
import {filterStatus, firstFrom} from '../alteration-kit/loose-end-kit'


export function mapToSubscriptionQuoteRequest(
    account: MrAccount,
    subscription?: MrSubscription
) {
    subscription ??= firstFrom(account?.subscriptions)

    const plans = values(subscription.plans)
    const policies = values(subscription.policies)

    const requestSubscription: MrSubscription = {
        ...subscription,
        policies: null,
        plans: null
    }

    const requestAccount: MrAccount = {
        ...account,
        subscriptions: null
    }

    const request: MrSubscriptionQuoteRequest = {
        quoteRequestId: newUUID(),
        quoteRequestTimestamp: Date.now(),
        account: requestAccount,
        plans,
        policies,
        subscription: requestSubscription,
    }

    return request
}






export function mapToQuoteRequest(
    lives: KeyMapped<Draft<MrLife>>,
    quoteParameterSet?: QuoteParameterSet,
): QuoteLifeRequest {
    const quoteRequest: QuoteLifeRequest = {
        quoteRequestId: newUUID(),
        quoteRequestTimestamp: Date.now(),
        quoteParamDefaults: quoteParameterSet?.defaults,
        quoteParamOverrides: quoteParameterSet?.overrides,
        lives: mapToQuoteLives(lives)
    }
    return quoteRequest
}


function mapToQuoteLives(lives: KeyMapped<Draft<MrLife>>): KeyMapped<QuoteLife> {
    const quoteLives =
        filterStatus(values(lives), 'ACTIVE')
            .map(mapToQuoteLife)
    return mapById(quoteLives)
}

function mapToQuoteLife(life: Draft<MrLife>): QuoteLife {
    return {
        ...structuredClone(pick(life,
            'id',
            'planId',
            'type',
            'dateOfBirth',
            'postcode',
        )),
        gender: life.gender ?? 'BLENDED',
        region: quoteRegionMap[life.address.region],
        benefits: mapToQuoteLifeBenefits(life.benefits),
    } as QuoteLife
}

function mapToQuoteLifeBenefits(lifeBenefits: KeyMapped<Draft<MrLifeBenefit>>): KeyMapped<QuoteBenefit> {
    const activeBenefits =
        filterStatus(values(lifeBenefits), 'ACTIVE')
            .map(mapToQuoteLifeBenefit)

    return mapBy(activeBenefits, b => b.id)
}

function mapToQuoteLifeBenefit(lifeBenefit: Draft<MrLifeBenefit>): QuoteBenefit {
    return {
        ...structuredClone(omit(lifeBenefit,
            'status',
            'endDate',
            'premium'
        )),
        id: toQuoteBenefitType(lifeBenefit.id)
    }
}
